import styled from '@emotion/styled';
import React from 'react';

import ContactMethods from './ContactMethods';
import Section from '../../../ComponentLibrary/layout/oc-section';
import { H2, H3 } from '../../../ComponentLibrary/text-elements/oc-h';

const StandOutsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  div {
    margin-top: 10px;
    width: 50%;
    padding-right: 10px;
  }
`;

const EstimationNotFound = ({ contractorName, contractorPhone, contractorEmail, standOuts }) => (
  <Section noMarginTop>
    <H2>Oh no! It looks like there has been an error</H2>
    <p>
      We are having trouble loading your quote estimation. Please try again or contact us directly to receive your
      quote.
    </p>
    <ContactMethods contractorPhone={contractorPhone} contractorEmail={contractorEmail} />
    <br />
    <H2 font="body">About {contractorName}</H2>
    <StandOutsContainer>
      {standOuts
        ?.filter(standOut => standOut.display)
        .map((standOut, index) => (
          <div key={`stand-out-${index}`}>
            <H3 font="body">{standOut.title}</H3>
            <p>{standOut.content}</p>
          </div>
        ))}
    </StandOutsContainer>
  </Section>
);

export default EstimationNotFound;
